import { useNavigation } from "@react-navigation/native";
import { Fade, ProductThumbnail, Text } from "@towersystems/roam-common-native";
import { useTheme } from "@towersystems/roam-common-native/lib/utilities/theme";
import { Pressable } from "react-native";
import { Spacings, View } from "react-native-ui-lib";
import { moneyToFormattedString } from "../../../../../../../utilities/money";
import { toInternalProductType } from "../../../../../../../utilities/to-internal-product-type";
import { SellScreenProps } from "../../../../../screens/SellScreen";
import { CartItemProductDetails } from "../components/CartItemProductDetails";
import { CartItemProps, OverridesType } from "../types";
import { useState } from "react";
import { Accordion } from "../../../../../../../components/Accordion";
import { AntDesign } from "@expo/vector-icons";

export type CartItemRendererProps = CartItemProps & {
  overrides?: OverridesType;
};

export const CartItemRenderer = ({
  product,
  item,
  overrides,
  children,
}: CartItemRendererProps) => {
  const { colors: Colors } = useTheme();
  const navigation = useNavigation<SellScreenProps["navigation"]>();

  const isSurcharge = item.metadata?.surcharge;
  const tintColor = isSurcharge === true ? Colors.surcharge : Colors.text;

  const [expanded, setExpanded] = useState(true);

  const handlePress = () => {
    setExpanded((prev) => !prev);
  };

  const contentMarkup = (
    <Pressable
      style={{ flex: 1, height: "100%" }}
      onPress={() =>
        navigation.navigate("CartItemModalRootScreen", {
          lineItemId: item.id,
        })
      }
    >
      <View
        row
        style={{
          paddingTop: 8,
          paddingBottom: 8,
          alignItems: "flex-start",
        }}
      >
        <View
          style={{
            flex: 1,
            alignItems: "center",
            flexBasis: "100%",
            flexShrink: 1,
          }}
          row
        >
          <View
            style={{
              alignItems: "center",
              flexBasis: "100%",
              flexShrink: 1,
            }}
            row
          >
            <View style={{ marginRight: Spacings.s4 }}>
              <ProductThumbnail
                imageUrl={product.imageUrl}
                quantity={item.quantity}
                isInternalProduct={
                  toInternalProductType(product) && product?.internal
                }
                internalProductType={toInternalProductType(product)}
              />
            </View>
            <CartItemProductDetails
              tintColor={tintColor}
              item={item}
              product={product}
            />
          </View>
        </View>
        <View style={{ height: "100%", justifyContent: "center" }}>
          <View style={{ alignItems: "flex-end", justifyContent: "center" }}>
            <Text
              style={{ fontSize: 18, fontWeight: "bold", color: tintColor }}
            >
              {moneyToFormattedString(
                overrides?.data?.totalPrice || item.totalPrice
              )}
            </Text>
            {overrides?.data?.hasAdjustments || item.hasAdjustments ? (
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  opacity: 0.8,
                  textDecorationLine: "line-through",
                  color: Colors.destructive,
                }}
              >
                {moneyToFormattedString(
                  overrides?.data?.totalBasePrice || item.totalBasePrice
                )}
              </Text>
            ) : undefined}
          </View>
        </View>
      </View>
    </Pressable>
  );

  if (!product.isKit) {
    return <Fade>{contentMarkup}</Fade>;
  }

  return (
    <Fade>
      <Accordion
        viewKey={`product-kit-accordion_${expanded}`}
        header={contentMarkup}
        expanded={expanded}
        onPress={handlePress}
      >
        {children ? (
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              paddingHorizontal: Spacings.s6,
              paddingTop: Spacings.s1,
            }}
          >
            <View style={{ opacity: 0 }}>
              <Pressable
                onPress={() => {}}
                style={{ marginRight: Spacings.s3 }}
              >
                <AntDesign name={"up"} size={24} color={"white"} />
              </Pressable>
            </View>
            {children}
          </View>
        ) : null}
      </Accordion>
    </Fade>
  );
};
